import { createElement } from 'react';
import { sanitizeHtml } from './sanitizeHtml';

export function Html({ html, className }: { html?: string; className?: string }) {
  if (!html) return null;
  return createElement('div', {
    className: `rich-html${className ? ` ${className}` : ''}`,
    dangerouslySetInnerHTML: { __html: sanitizeHtml(html) },
  });
}
